import type {ReactElement} from 'react';
import type {PlanTableProps} from './plan-table.types';
import styles from './plan-table.module.scss';

export function PlanTable({steps}: PlanTableProps): ReactElement {
  return (
    <div className={styles.planTable} role="table" aria-label={window.i18next.t('pmwjs_plan')}>
      {steps.map((step) => (
        <div key={step.number} className={styles.row} role="row">
          <div className={styles.stepNumber} role="rowheader" aria-label={`${window.i18next.t('pmwjs_step')} ${step.number}`}>
            {step.number}
          </div>
          <div className={styles.task} role="cell">
            {step.task}
          </div>
        </div>
      ))}
    </div>
  );
}
